// extracted by mini-css-extract-plugin
module.exports = {"formsOverviewListPanel":"FormsOverviewListPanel_formsOverviewListPanel__m5ICY"};